import React from "react";
import OwLabel from "../OwLabel/OwLabel";
import OwTranslate from "../OwTranslate/OwTranslate";

type Props = {
    subject: string;
    className?: string;
};

const WhatsThis = (props: Props) => {
    const [displayHowTo, setDisplayHowTo] = React.useState(false);

    const toggleHowTo = () => {
        setDisplayHowTo(!displayHowTo);
    };

    return (
        <div className={"WhatsThis " + (props.className || "")}>
            <div className={"mb-2"}>
                <span className="pointer faded-orange" onClick={toggleHowTo}>
                    <i className="fas fa-info-circle" /> <OwTranslate defaultMessage={"What's this"} id={"whats_this"} />?
                </span>
            </div>
            <ul className={"text-muted " + (displayHowTo ? "" : "d-none")}>
                <p>
                    <OwLabel title={props.subject} preserveNewlines={true} />
                </p>
            </ul>
        </div>
    );
};

export default WhatsThis;
